// ../../packages/build/src/injections/dev.js
var __DEV__ = process.env.NODE_ENV !== "production";

// src/constants.ts
var SENDER = "storage";
var OPTIONS = {
  type: "local",
  prefix: "harlem",
  sync: true
};
var STORAGE = {
  local: localStorage,
  session: sessionStorage
};

// src/index.ts
function createStoragePlugin(stores, options = OPTIONS) {
  const {
    type,
    prefix,
    sync
  } = {
    ...OPTIONS,
    ...options
  };
  const storage = STORAGE[type] || STORAGE.local;
  const getKey = (name) => {
    return prefix ? `${prefix}:${name}` : name;
  };
  const canStore = (name) => {
    return stores === "*" || [].concat(stores).includes(name);
  };
  return {
    name: "storage",
    install(app, eventEmitter, internalStores) {
      const mutationHook = (payload) => {
        if (!payload || payload.sender === SENDER || !canStore(payload.store)) {
          return;
        }
        const store = internalStores.get(payload.store);
        if (!store) {
          return;
        }
        const key = getKey(payload.store);
        const state = store.state;
        storage.setItem(key, JSON.stringify(state));
      };
      eventEmitter.on("mutation:after", mutationHook);
      if (!sync) {
        return;
      }
      window.addEventListener("storage", (event) => {
        if (event.storageArea !== storage) {
          return;
        }
        const value = event.newValue;
        const entry = Array.from(internalStores).find(([key, value2]) => {
          return canStore(key) && event.key === getKey(key);
        });
        if (!entry || !value) {
          return;
        }
        const [
          name,
          store
        ] = entry;
        store.write("plugin:storage:sync", SENDER, (state) => {
          Object.assign(state, JSON.parse(value));
        });
      });
    }
  };
}
export {
  createStoragePlugin as default
};
//# sourceMappingURL=harlem-storage.bundler.esm.js.map
